import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Col, Input, Row, Typography } from "antd";
import { Icon } from "assets/icons";
import CustomModal from "components/CustomModal";
import CustomTable from "components/CustomTable";
import SellerTagList from "pages/App/Agent/List/components/SellerTagList";
import "./index.scss";
import useAgentShowModal from "./useAgentShowModal";

export const AgentShowModal = ({ visible, onCancel, voucherID }) => {
  const { loading, columns, dataSeller, paginationData, handleSearch, onTableChange, handleCloseTag, params } =
    useAgentShowModal({ voucherID });

  return (
    <div className="custom-modal-select-product">
      <CustomModal
        {...{
          message: <Typography.Title level={4}>Danh sách đại lý áp dụng ưu đãi</Typography.Title>,
          footer: false,
          width: "70%",
          visible: visible,
          onOke: onCancel,
          onCancel: onCancel,
          buttonLoading: loading,
          hideCancelButton: true,
          okeButtonLabel: "Đóng",
          children: (
            <>
              <Row
                gutter={[16, 4]}
                style={{
                  alignItems: "center",
                  borderRadius: "8px",
                  margin: 0,
                }}
              >
                <Col span={24} style={{ marginBottom: "12px" }}>
                  <div className="custom-search-product-wrapper">
                    <Input
                      prefix={<FontAwesomeIcon icon={Icon.faSearch} />}
                      placeholder="Tìm kiếm theo mã đại lý hoặc tên đại lý"
                      onChange={handleSearch}
                      allowClear={true}
                      value={params.filters.query || ""}
                      style={{ width: "350px" }}
                    />
                  </div>
                </Col>
              </Row>
              <Col span={24}>
                <SellerTagList filters={params.filters} onClose={handleCloseTag} />
              </Col>
              <Row gutter={[16, 16]}>
                <Col span={24}>
                  <CustomTable
                    columns={columns}
                    loading={loading}
                    dataSource={dataSeller}
                    rowKey={(record) => record?.id}
                    onChange={onTableChange}
                    pagination={{
                      total: paginationData?.total,
                      pageSize: paginationData?.limit,
                      current: paginationData?.offset / paginationData?.limit + 1 || 1,
                      showSizeChanger: false,
                    }}
                    scroll={{ x: "max-content", y: "500px" }}
                  />
                </Col>
              </Row>
            </>
          ),
        }}
      />
    </div>
  );
};
